var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-multi" }),
        _vm._v(_vm._s(_vm.$t("Label Firmware")) + " ")
      ]),
      _c("div", { staticClass: "searchArea" }, [
        _c(
          "div",
          { staticClass: "row align-end" },
          [
            _c("v-select", {
              staticClass: "form-select ml-3 col-3",
              attrs: {
                label: _vm.$t("Label Type"),
                placeholder: _vm.$t("Select label type"),
                "item-text": "name",
                "item-value": "item",
                items: _vm.labelTypeList,
                outlined: "",
                dense: "",
                "hide-details": "",
                clearable: "",
                return: "",
                object: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("span", { staticClass: "selection-item-list" }, [
                        _vm._v(_vm._s(_vm.getText(item)))
                      ])
                    ]
                  }
                },
                {
                  key: "selection",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("span", { staticClass: "selection-v-select" }, [
                        _vm._v(_vm._s(_vm.getText(item)))
                      ])
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.labelTypeListData,
                callback: function($$v) {
                  _vm.labelTypeListData = $$v
                },
                expression: "labelTypeListData"
              }
            }),
            _c("v-select", {
              staticClass: "form-select ml-3 col-3",
              attrs: {
                label: _vm.$t("Label Class"),
                placeholder: _vm.$t("Select label class"),
                "item-text": "name",
                "item-value": "level",
                items: _vm.tagClassList,
                outlined: "",
                dense: "",
                "hide-details": "",
                clearable: ""
              },
              model: {
                value: _vm.tagClassListData,
                callback: function($$v) {
                  _vm.tagClassListData = $$v
                },
                expression: "tagClassListData"
              }
            }),
            _c(
              "v-btn",
              {
                staticClass: "btn type-search ml-2",
                staticStyle: { height: "39px" },
                attrs: { text: "" },
                on: { click: _vm.searchOTAData }
              },
              [_vm._v(_vm._s(_vm.$t("Search")) + " ")]
            )
          ],
          1
        )
      ]),
      _c(
        "v-data-table",
        {
          staticClass: "tbl-type01 mt-10 products",
          attrs: {
            "item-key": "id",
            headers: _vm.labelFirmwareListHeaders,
            items: _vm.labelFirmwareList,
            "hide-default-footer": true,
            "items-per-page": 10,
            "fixed-header": "",
            "single-select": "",
            "show-select": "",
            options: _vm.options
          },
          on: {
            "update:options": function($event) {
              _vm.options = $event
            }
          },
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [
          _c("template", { slot: "no-data" }, [
            _c("p", [_vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")])
          ])
        ],
        2
      ),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _c("label-firmware-uploader", {
              attrs: { btnDisabledFileUpload: _vm.btnDisabledFileUpload },
              on: { initLabelFirmware: _vm.initLabelFirmware }
            }),
            _c(
              "v-btn",
              {
                staticClass: "btn  ml-2",
                attrs: {
                  disabled: _vm.btnDisabledFileUpload || _vm.checkSelected,
                  text: ""
                },
                on: {
                  click: function($event) {
                    return _vm.todeleteLabelfirmware(false)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Delete")))]
            )
          ],
          1
        ),
        _c("div", { staticClass: "pageInfo" }, [
          _vm._v(" " + _vm._s(_vm.pageInfoText) + " ")
        ]),
        _c(
          "div",
          [
            _c("v-pagination", {
              staticClass: "pageAlign",
              attrs: { length: _vm.totalPages, "total-visible": 7 },
              on: { input: _vm.paging },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ]),
      _c("a", { ref: "link", style: { display: "none" } }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "300" },
          model: {
            value: _vm.delmessageDialog,
            callback: function($$v) {
              _vm.delmessageDialog = $$v
            },
            expression: "delmessageDialog"
          }
        },
        [
          _c(
            "v-card",
            {
              staticClass: "popup add_store_popup",
              attrs: { align: "center", justify: "center" }
            },
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c("v-col", [
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.messageText) }
                    })
                  ])
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: {
                        text: "",
                        icon: "",
                        disabled: _vm.btnDisabledDetail,
                        "max-width": "100"
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmForceDelete()
                        }
                      }
                    },
                    [_vm._v("Delete")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "", "max-width": "100" },
                      on: {
                        click: function($event) {
                          _vm.delmessageDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }